/**
 * Count formatting for the shared box components: opens, weights, anything that
 * is not an amount. Amounts (prices, values, balances) are integer US cents and go
 * through api-contract's `formatAmount` with the environment's currency instead.
 *
 * The locale is pinned rather than left to the browser, for the same reason
 * `formatAmount` pins it. These components render in two places — the shopper's
 * storefront and the staff dashboard's preview of it — and a preview whose
 * thousands separator depends on the staff member's locale would disagree with
 * the store it claims to be showing.
 */
const numberFormat = new Intl.NumberFormat("en-US");

export function formatNumber(n: number): string {
  return numberFormat.format(n);
}
